<template>
  <div v-if="isHelpModalOpen" class="helpModal">
    <div class="helpModal-background" @click="closeHelpModal"></div>
    <div class="helpModal-content">
      <h5 class="title is-5">How to Set Non-Detection Areas</h5>
      <br />
      <h5 class="title is-5">1. Adding a New Area</h5>
      <p>• Click on "+ Add Area" to add a new area.</p>
      <p>• You can add vertices to the area by clicking.</p>
      <p>• Clicking on the initially selected vertex completes the addition.</p>
      <br />
      <h5 class="title is-5">2. Deleting an Area</h5>
      <p>
        • Select the area you want to delete from the "Non-Detection Area Menu."
      </p>
      <p>• Click "Delete" to remove the selected area.</p>
      <br />
      <h5 class="title is-5">3. Registering Non-Detection Areas</h5>
      <p>
        • Click the "Confirm" button to complete the setup of non-detection
        areas.
      </p>
      <br />
      <button @click="closeHelpModal" class="button is-danger ml-3">
        Close
      </button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "UndetectedAreaEnus",
  props: {
    isHelpModalOpen: Boolean,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const closeHelpModal = () => {
      emit("close");
    };
    return { closeHelpModal };
  },
});
</script>

<style>
.helpModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.helpModal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.helpModal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
